'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "toolbarTooltip"];
import PropTypes from 'prop-types';
import { createContext, Component } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const DisabledContext = /*#__PURE__*/createContext(false);
class Disableable extends Component {
  render() {
    const _this$props = this.props,
      {
        disabled,
        toolbarTooltip
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(DisabledContext.Provider, {
      value: disabled,
      children: /*#__PURE__*/_jsx(UITooltip, Object.assign({
        disabled: !disabled || !toolbarTooltip,
        placement: "bottom",
        title: toolbarTooltip
      }, rest, {
        children: this.props.children
      }))
    });
  }
}
Disableable.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node,
  toolbarTooltip: PropTypes.string
};
Disableable.defaultProps = {
  disabled: false
};
export default Disableable;